import { createSelector } from 'reselect'

const selectUserRole = state => state.get('userRole')
const selectUserStatus = () => createSelector(selectUserRole, userRole => userRole.toJS()['status'])
const selectNewRole = () => createSelector(selectUserRole, userRole => userRole.toJS()['newRole'])

export { selectUserStatus, selectNewRole }
